import React, { useState, useEffect } from "react";
import Select from "react-select";   // ✅ import react-select
import api from "../api";
import Loader from "./Loader";

const TransactionForm = ({ onTransactionAdded }) => {
  const [vehicles, setVehicles] = useState([]);
  const [formData, setFormData] = useState({
    vehicle_no: "",
    collection_date: new Date().toISOString().slice(0, 10),
    amt_received: "",
    payment_mode: "Cash",
    txn_id: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const res = await api.get("/vehicles");
        setVehicles(res.data || []);
      } catch (error) {
        console.error(
          "Error fetching vehicles:",
          error.response ? error.response.data : error.message
        );
      }
    };
    fetchVehicles();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleVehicleChange = (selectedOption) => {
    setFormData({ ...formData, vehicle_no: selectedOption?.value || "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await api.post("/transactions", {
        ...formData,
        amt_received: parseFloat(formData.amt_received),
        vehicle_numbers: [formData.vehicle_no],
      });
      alert("Transaction submitted successfully!");
      if (onTransactionAdded) onTransactionAdded();

      setFormData({
        vehicle_no: "",
        collection_date: new Date().toISOString().slice(0, 10),
        amt_received: "",
        payment_mode: "Cash",
        txn_id: "",
      });
    } catch (error) {
      console.error(
        "Error submitting transaction:",
        error.response ? error.response.data : error.message
      );
      alert(
        `Error: ${error.response ? error.response.data.message : error.message}`
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 bg-white dark:bg-gray-800 h-full overflow-y-auto">
      {isSubmitting && <Loader />}
      <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-6">
        Add Vehicle Transaction
      </h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Searchable Vehicle Dropdown */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Vehicle Number
          </label>
          <Select
            options={vehicles.map((v) => ({
              value: v.vehicle_no,
              label: v.vehicle_no,
            }))}
            value={
              formData.vehicle_no
                ? { value: formData.vehicle_no, label: formData.vehicle_no }
                : null
            }
            onChange={handleVehicleChange}
            placeholder="Search or select vehicle..."
            isClearable
            isDisabled={isSubmitting}
          />
        </div>

        <InputField
          label="Collection Date"
          name="collection_date"
          type="date"
          value={formData.collection_date}
          onChange={handleChange}
          required
          disabled={isSubmitting}
        />
        <InputField
          label="Amount Received"
          name="amt_received"
          type="number"
          value={formData.amt_received}
          onChange={handleChange}
          required
          disabled={isSubmitting}
        />
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
            Payment Mode
          </label>
          <select
            name="payment_mode"
            value={formData.payment_mode}
            onChange={handleChange}
            className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
            disabled={isSubmitting}
          >
            <option>Cash</option>
            <option>Online</option>
            <option>Cheque</option>
          </select>
        </div>
        <InputField
          label="Transaction ID (optional)"
          name="txn_id"
          value={formData.txn_id}
          onChange={handleChange}
          disabled={isSubmitting}
        />
        <div className="pt-6">
          <button
            type="submit"
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit Transaction'}
          </button>
        </div>
      </form>
    </div>
  );
};

const InputField = ({ label, ...props }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
      {label}
    </label>
    <input
      {...props}
      className="mt-1 block w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  </div>
);

export default TransactionForm;
